'use client';

import { c as _c } from "react/compiler-runtime";
import { useCouponId, useCouponIndices } from '@svs/nova-poolbetting/core/frameworks/nextjs/coupon';
import type { ReactNode } from 'react';
import BetButtons from './BetButtons';

/**
 * Client container component that renders BetButtons for a coupon.
 *
 * @returns The bet buttons client container component
 */
export default function BetButtonsClientContainer() {
  const $ = _c(5);
  const [couponId] = useCouponId();
  let t0;
  if ($[0] !== couponId) {
    t0 = {
      couponId
    };
    $[0] = couponId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const couponIndices = useCouponIndices(t0);
  let t1;
  if ($[2] !== couponId || $[3] !== couponIndices) {
    t1 = <BetButtons couponIndices={couponIndices} couponId={couponId} />;
    $[2] = couponId;
    $[3] = couponIndices;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
}